import { Injectable } from '@angular/core';

import { ROUTING_PATH } from '@shared/constants/routingPath';

import {
  TrialInsightsPaymentMilestoneKey,
  TrialInsightsTableModel,
  TrialInsightsTableOptions,
  TrialInsightsTableRowData,
} from '../../models/trial-insights-table.model';

@Injectable({
  providedIn: 'root',
})
export class TrialInsightsPaymentMilestonesTableService implements TrialInsightsTableModel {
  route = ROUTING_PATH.BUDGET.INDEX;
  subRoute = `${ROUTING_PATH.BUDGET.PAYMENTS.INDEX}/${ROUTING_PATH.BUDGET.PAYMENTS.PAYMENT_MILESTONES}`;

  createTable = (
    selectedKey: TrialInsightsPaymentMilestoneKey = TrialInsightsPaymentMilestoneKey.MILESTONES,
    rowData: TrialInsightsTableRowData[] = []
  ): TrialInsightsTableOptions => {
    return {
      buttons: {
        data: [{ key: 'milestones', value: 'Milestones' }],
        defaultButtonKey: selectedKey,
        display: true,
      },
      header: {
        data: [{ buttonKey: 'milestones', leftValue: 'Milestone', rightValue: 'Payment' }],
        display: true,
      },
      link: {
        display: true,
        url: `/${this.route}/${this.subRoute}`,
        value: 'See All Payment Milestones',
      },
      rowData: {
        compact: false,
        data: rowData,
      },
    };
  };
}
